import getProductSpec from '../../context/getSpec';
import css from './index.module.scss';
import EcoSpecSelector from 'eco-design/sections/eco-spec-selector';
import { Spin } from 'antd';

export default function Support({ productSpecs, theme, title }: any) {
    return (
        <div className={`spec ${css.spec}`}>
            {productSpecs ? (
                <EcoSpecSelector {...productSpecs} />
            ) : (
                <>
                    {getProductSpec(title, theme)}
                    <Spin />
                </>
            )}
        </div>
    );
}
